import { FileUploadStatus, FinalFileProcessingStatus } from "../study/study.types";

export interface WebSocketState {
    isConnected: boolean;
    // Increments on every successful reconnect so components can watch for reconnections
    // and refetch any state that may have been missed while the socket was down.
    wsReconnectedCount: number;
    importCitationEventState: ImportCitationWSMessage | undefined;
    newImportEventState: NewImportWSMessage | undefined;
    fileDismissEventState: FileDismissWSMessage | undefined;
    studyUpdateEventState: StudyUpdateWSMessage | undefined;
    accountDetailErrorEventState: AccountDetailsErrorWSMessage | undefined;
}

// TODO: Move this to jbi shared, so it can be shared with backend
export enum WEBSOCKET_EVENTS {
    JOIN_ROOM = 'JOIN_ROOM',
    LEAVE_ROOM = 'LEAVE_ROOM',
    IMPORT_CITATIONS_EVENT = 'IMPORT_CITATIONS_EVENT',
    NEW_IMPORT_EVENT = 'NEW_IMPORT_EVENT',
    FILE_DISMISS_EVENT = 'FILE_DISMISS_EVENT',
    STUDY_UPDATE_EVENT = 'STUDY_UPDATE_EVENT',
    ACCOUNT_DETAILS_ERROR_EVENT = 'ACCOUNT_DETAILS_ERROR_EVENT'
}

// TODO: Move this to jbi shared, so it can be shared with backend
export const constructRoomId = (room: EventRoom) => `${room.projectId}|${room.event}`;

// TODO: Move this to jbi shared, so it can be shared with backend
export interface EventRoom {
    projectId: number;
    event: WEBSOCKET_EVENTS;
}

// TODO: Move this to jbi shared, so it can be shared with backend
export interface ImportCitationWSMessage {
    fileId: number;
    userId: number;
    status: FileUploadStatus;
    numberOfRecords?: number;
    corruptionDetected?: boolean;
}

// TODO: Move this to jbi shared, so it can be shared with backend
export interface NewImportWSMessage {
    hasNewImport: boolean;
}

// TODO: Move this to jbi shared, so it can be shared with backend
export interface FileDismissWSMessage {
    dismissedFileIds: number[];
    status: FinalFileProcessingStatus;
}

export interface AccountDetailsErrorWSMessage {
    errorMessage: string;
}

// In future if there are more WS events this can be multiple separate with | operator
export type WebSocketMessage = ImportCitationWSMessage | NewImportWSMessage | FileDismissWSMessage | StudyUpdateWSMessage | AccountDetailsErrorWSMessage;

export interface UpdateWSEventStatePayload {
    event: WEBSOCKET_EVENTS;
    message: WebSocketMessage;
}

export interface StudyUpdateWSMessage {
    studyIds: number[];
}